import React, { useState, useEffect } from "react";
import { get } from "lodash";
import { useQuery } from "@apollo/client";
import { VersionMenuContainer, VersionMenuTitle, VersionMenuSubTitle } from "./styled";
import VersionDisplay from "../presentational/VersionDisplay";
import NoVersionDisplay from "../presentational/VersionDisplay/NoVersionDisplay";
import DraftVersionDisplay from "../presentational/VersionDisplay/DarftVersionDisplay";
import { GET_LEARNING_UNIT_VERSIONS_MANIFEST } from "./queries";

const VersionMenu = ({
  collapsed,
  subjectId,
  tutorialId,
  learningUnitId,
  selectedVersion,
  setSelectedVersion,
  lastModifiedBy,
  setVMRefetchFn,
}) => {
  const { data, error, loading, refetch } = useQuery(GET_LEARNING_UNIT_VERSIONS_MANIFEST, {
    variables: {
      tutorialId,
      learningUnitId,
    },
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    setVMRefetchFn({ refetch });
  }, []);

  useEffect(() => {
    refetch();
  }, [selectedVersion, refetch]);

  const versions = get(data, "getLearningUnitVersionsManifest.versions");
  const learningUnit = get(data, "getLearningUnitVersionsManifest.learningUnit");

  useEffect(() => {
    if (selectedVersion === undefined && learningUnit !== undefined && versions !== undefined) {
      setSelectedVersion(get(!learningUnit.isPublished || versions, "0._id", ""));
    }
  }, [selectedVersion, learningUnit, versions, setSelectedVersion]);

  // const [selectedVersion, setSelectedVersion] = useState(version);

  if (error) return <div> ERROR </div>;
  if (loading) return <div> </div>;

  let subHead = "";

  return (
    <VersionMenuContainer $collapsed={collapsed}>
      <VersionMenuTitle>
        <h2>Version Management</h2>
      </VersionMenuTitle>
      {!learningUnit.isPublished ? (
        <>
          <VersionMenuSubTitle>Unpublished Versions</VersionMenuSubTitle>
          <DraftVersionDisplay
            lastModifiedBy={lastModifiedBy}
            selected={selectedVersion === ""}
            setSelectedVersion={setSelectedVersion}
            subjectId={subjectId}
            tutorialId={tutorialId}
            learningUnitId={learningUnitId}
          />
        </>
      ) : (
        ""
      )}
      <VersionMenuSubTitle>Published Versions</VersionMenuSubTitle>
      {versions.length > 0 ? (
        versions
          .filter((v) => v.isPublished)
          .map((version, key) => {
            const shouldDisplaySubHead = version.month === subHead;
            subHead = "month";
            return (
              <div key={key}>
                {shouldDisplaySubHead ? <VersionMenuSubTitle>MONTH</VersionMenuSubTitle> : ""}
                <VersionDisplay
                  version={version}
                  selected={version._id === selectedVersion}
                  setSelectedVersion={setSelectedVersion}
                  subjectId={subjectId}
                  tutorialId={tutorialId}
                  learningUnit={learningUnit}
                  refetch={refetch}
                />
              </div>
            );
          })
      ) : (
        <NoVersionDisplay />
      )}
    </VersionMenuContainer>
  );
};

export default VersionMenu;
